import { LayoutHOC } from "base/ui/layout/layout";
import React from "react";
import { createPivotTable } from "./pivot";

export const createPivotTablePage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createPivotTable());
};
